import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const ignoredErrorMessages = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
  'process is not defined',
  'Unexpected token',
  'No token provided.',
];

const shouldIgnoreError = (value = '') => {
  const message = String(value || '');

  return ignoredErrorMessages.some((entry) => message.includes(entry));
};

if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const nativeConsoleError = window.console.error;

window.console.error = (...args) => {
  const joinedMessage = args
    .map((item) => (typeof item === 'string' ? item : item?.message || ''))
    .join(' ');

  if (shouldIgnoreError(joinedMessage)) {
    return;
  }

  nativeConsoleError(...args);
};

window.addEventListener('error', (event) => {
  if (shouldIgnoreError(event.message) || shouldIgnoreError(event.error?.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (shouldIgnoreError(event.reason?.message) || shouldIgnoreError(event.reason)) {
    event.preventDefault();
  }
}, true);

window.onerror = (message) => {
  if (shouldIgnoreError(message)) {
    return true;
  }

  return false;
};

const App = require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
